var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DialogContent } from '@mui/material';
import React from 'react';
import { ariaContentDefaultId } from './ariaIds';
/**
 * Content container for a modal slideout dialog.
 *
 * @param {object} root0 - Component props.
 * @param {boolean} [root0.ariaDescribeAllChildren=true] - Whether to assign default ARIA description ID to all children.
 * @param {React.ReactNode} root0.children - Child elements to be rendered inside the dialog content.
 * @returns {JSX.Element} The rendered DialogContent element.
 */
export const ModalSlideoutContent = (_a) => {
    var { ariaDescribeAllChildren = true, children } = _a, props = __rest(_a, ["ariaDescribeAllChildren", "children"]);
    return (React.createElement(DialogContent, { id: ariaDescribeAllChildren ? ariaContentDefaultId : undefined, sx: { p: 0 }, "data-test": props['data-test'] }, children));
};
